// Утилиты для работы с PWA

// Проверяем, установлено ли приложение как PWA
export const isPWAInstalled = () => {
  // Проверяем различные способы определения PWA
  if (typeof window !== 'undefined') {
    // Проверяем display-mode
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    
    // Проверяем navigator.standalone для iOS
    if (window.navigator && window.navigator.standalone) {
      return true;
    }
    
    // Проверяем наличие PWA в window
    if (window.deferredPrompt) {
      return true;
    }
  }
  
  return false;
};

// Проверяем, запущено ли приложение в standalone режиме (PWA)
export const isStandalone = () => {
  if (typeof window !== 'undefined') {
    return window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
  }
  return false;
};

// Проверяем, запущено ли приложение в fullscreen режиме
export const isFullscreen = () => {
  if (typeof window !== 'undefined') {
    return window.matchMedia && window.matchMedia('(display-mode: fullscreen)').matches;
  }
  return false;
};

// Получаем информацию о безопасных зонах
export const getSafeAreaInsets = () => {
  if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) {
    const supportsEnv = window.CSS.supports('padding-top: env(safe-area-inset-top)');
    if (supportsEnv) {
      return {
        top: getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top') || '0px',
        bottom: getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom') || '0px',
        left: getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-left') || '0px',
        right: getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-right') || '0px'
      };
    }
  }
  return { top: '0px', bottom: '0px', left: '0px', right: '0px' };
};

// Проверяем, является ли устройство мобильным
export const isMobile = () => {
  if (typeof window !== 'undefined') {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  return false;
};

// Проверяем, является ли устройство iOS
export const isIOS = () => {
  if (typeof window !== 'undefined') {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }
  return false;
};

// Проверяем, запущено ли приложение в iOS PWA режиме
export const isIOSPWA = () => {
  if (typeof window !== 'undefined') {
    return isIOS() && isStandalone();
  }
  return false;
};

// Получаем правильные отступы для iOS PWA
export const getIOSPWAPadding = () => {
  if (isIOSPWA()) {
    return {
      top: `max(env(safe-area-inset-top), 20px)`,
      bottom: '0px',
      left: 'env(safe-area-inset-left)',
      right: 'env(safe-area-inset-right)'
    };
  }
  return {
    top: 'env(safe-area-inset-top)',
    bottom: 'env(safe-area-inset-bottom)',
    left: 'env(safe-area-inset-left)',
    right: 'env(safe-area-inset-right)'
  };
};

// Проверяем, является ли устройство Android
export const isAndroid = () => {
  if (typeof window !== 'undefined') {
    return /Android/.test(navigator.userAgent);
  }
  return false;
};
